/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdc_Action_PrintInputs */

const vi_pdc_action_print = /** @type {(inputs: Pdc_Action_PrintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In phiếu`)
};

/**

* @param {Pdc_Action_PrintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pdc_action_print = /** @type {((inputs?: Pdc_Action_PrintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdc_Action_PrintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pdc_action_print(inputs)
});